import { AnalyticsApiError } from "../../../utils/analytics/adminAnalyticsApi";
import { messages } from "../../../locales/messages";
import { toastError } from "../../../utils/pageUtil/toast";

export async function handleAnalyticsError(
  error: unknown,
  t: (k: any) => string,
): Promise<number | undefined> {
  if (!(error instanceof AnalyticsApiError)) {
    toastError(t(messages.There_is_an_error_please_Contact_Administrator()));
    return undefined;
  }

  if (error.status === 403) {
    toastError(
      error.message || t(messages.Analytics_FilterOutOfScope()),
    );
    return 403;
  }

  if (error.status === 503) {
    return 503;
  }

  if (error.status !== 401) {
    toastError(
      error.message ||
        t(messages.There_is_an_error_please_Contact_Administrator()),
    );
  }

  return error.status;
}
